import { Box, Typography } from '@mui/material';
import { authScreen } from './authScreenStyles';

export default function AuthAlert({ message, tone }: { message: string; tone: 'error' | 'success' }) {
  const isError = tone === 'error';
  return (
    <Box
      role="alert"
      sx={{
        mb: 2,
        px: 1.5,
        py: 1.15,
        borderRadius: authScreen.fieldRadius,
        border: `1px solid ${isError ? 'rgba(248, 113, 113, 0.35)' : 'rgba(74, 222, 128, 0.3)'}`,
        bgcolor: isError ? 'rgba(248, 113, 113, 0.08)' : 'rgba(74, 222, 128, 0.08)',
      }}
    >
      <Typography sx={{ fontSize: '0.8125rem', lineHeight: 1.45, color: authScreen.text, fontFamily: authScreen.font }}>
        {message}
      </Typography>
    </Box>
  );
}
